<script>
import Radio from "@/pages/components/form/horizontal/radio.vue";
import formInput from "@wielink-application/shared/js/mixins/formInput";

export default {
  mixins: [formInput],
  components: {Radio},
  props: {
    label: {
      type: String
    },
    options: {
      type: Array,
      required: true
    },
    layout: {
      type: String,
      default: 'horizontal'
    }
  }
}
</script>

<template>
  <div class="d-flex column-gap-3 row-gap-2" :class="{'flex-column' : layout === 'vertical'}">
    <Radio
        v-bind="$attrs"
        v-for="(option, index) in options"
        :key="index"
        @update:modelValue="$emit('update:modelValue', $event)"
        :model-value="modelValue"
        :form="form"
        :name="name"
        :id="`${this.renderedId}-${index}`"
        :value="option.value"
        :label="option.label"
    />
  </div>
</template>